import React from "react"
import { Box, Typography } from "@mui/material"


export default function HierarchicalTextBlock({ supertitle="", supertitleValue, title="", titleValue, subtitle="", subtitleValue, sx={}, ...props }) {
    return <Box sx={sx}>
        {!!supertitleValue && <Box className="infoContainer" sx={{...props?.sxContainers}}>
            <Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "0.8rem" }}>
                {supertitle}
            </Typography>
            <Typography variant="body2" className="value" sx={{ display: "inline", fontSize: "0.8rem", ...sx?.supertitleValue }}>
                {supertitleValue}
            </Typography>
        </Box>}
        {!!titleValue && <Box className="infoContainer" sx={{...props?.sxContainers}}>
            <Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "0.8rem" }}>
                {title}
            </Typography>
            <Typography variant="body2" className="value" sx={{ display: "inline", fontSize: "0.8rem", ...sx?.titleValue }}>
                {titleValue}
            </Typography>
        </Box>}
        {!!subtitleValue && <Box className="infoContainer" sx={{...props?.sxContainers}}>
            <Typography variant="subtitle2" className="label" sx={{ display: "inline", fontSize: "0.8rem" }}>
                {subtitle}
            </Typography>
            <Typography variant="body2" className="value" sx={{ display: "inline", fontSize: "0.8rem", ...sx?.subtitleValue }}>
                {subtitleValue}
            </Typography>
        </Box>}
    </Box>
}